import { createFileRoute, notFound } from "@tanstack/react-router"

import { loadPolicyChange } from "@/components/terminal/policy-change/policy-change-data"
import { PolicyChangePage } from "@/components/terminal/policy-change/policy-change-page"
import { getTerminalHeadMeta, TERMINAL_TITLE } from "@/lib/terminal/metadata"

const PolicyChange = () => <PolicyChangePage data={Route.useLoaderData()} />

// The Policy 1.0 to 2.0 walkthrough in Home's center well, opened from the
// account menu as Definitions is, for the Portfolios that get one (Dhanur,
// 26 Oct 2026). The loader's server function admits only the Portfolio's
// users and admins.
export const Route = createFileRoute("/_terminal/terminal/policy-2-0")({
  staticData: { shellMode: "page" },
  head: () => ({
    meta: getTerminalHeadMeta(`Policy 2.0 | ${TERMINAL_TITLE}`),
  }),
  loaderDeps: ({ search }) => ({ portfolio: search.portfolio }),
  loader: ({ deps }) => {
    if (!deps.portfolio) throw notFound()
    return loadPolicyChange({ data: { portfolioSlug: deps.portfolio } })
  },
  component: PolicyChange,
})
